import { Box, Typography } from '@mui/material';
import ReusableGrid from '../../../../components/Grid/index.jsx';

export const Card = ({ title, data, columns }) => (
  <Box>
    <Typography variant="h5" fontWeight={600} sx={{ mb: '24px' }}>
      {title}
    </Typography>
    {data.length > 0 && (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
        {data.map((item) => (
          <Box key={item.name}>
            <Typography sx={{ mb: '12px' }} variant="h6" fontWeight={600}>
              {item.name}
            </Typography>
            <ReusableGrid columns={columns} rows={item.data} footer={item.footer} />
          </Box>
        ))}
      </Box>
    )}
  </Box>
);
